








import Vue from "vue";
import LoginForm from "./components/LoginForm.vue";
import axios from "axios";

export default Vue.extend({
  name: "App",

  components: {
    LoginForm,
  },

  mounted(): void {
    this.fetchFavicon();
  },

  methods: {
    fetchFavicon(): void {
      axios
        .get("../REST/loginconfig/config/company/icon/data", {
          responseType: "blob",
        })
        .then((response) => {
          // Create a Blob object from the received favicon data
          const blob: Blob = new Blob([response.data], {
            type: "image/x-icon",
          });

          // Create a URL for the Blob object
          const faviconUrl: string = URL.createObjectURL(blob);

          // Set the favicon URL in the document head
          this.setFavicon(faviconUrl);
        })
        .catch((error) => {
          console.error("Error fetching favicon:", error);
          // If there's an error fetching the favicon, set the default favicon from window.config.defaultFaviconUrl
          const defaultFaviconUrl = window.config.defaultFaviconUrl;
          this.setFavicon(defaultFaviconUrl);
        });
    },
    setFavicon(url: string): void {
      const link: HTMLLinkElement =
        (document.querySelector("link[rel='icon']") as HTMLLinkElement) ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "icon";
      link.href = url;
      document.getElementsByTagName("head")[0].appendChild(link);
    },
  },
});
